import React from "react";
import { Grid } from "@mui/material";
import { EmptySection } from "~/components/vulnerabilities";
import { ListCaseEdges } from "~/pages/tickets/types";
import { TicketsTable } from "~/pages/tickets/tickets/TicketsTable/TicketsTable";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import { TicketsSkeleton } from "~/pages/tickets/tickets/TicketsPage/TicketsSkeleton/TicketsSkeleton";
import { PaginateProps } from "~/components/pagination/paginate";

type ClosedCasesProps = {
  closedCases: ListCaseEdges;
  isLoading: boolean;
  scope: SpaceOrWorkspaceScope;
  paginateProps: PaginateProps;
};

export const ClosedTickets = ({
  closedCases,
  isLoading,
  paginateProps,
  scope,
}: ClosedCasesProps) => {
  const isEmpty = closedCases.length === 0;

  return (
    <Grid size={12}>
      {isLoading ? (
        <TicketsSkeleton />
      ) : isEmpty ? (
        <EmptySection
          id="closed-cases-empty"
          text="There are currently no closed tickets."
        />
      ) : (
        <TicketsTable
          isLoading={isLoading}
          tickets={closedCases}
          scope={scope}
          paginateProps={paginateProps}
        />
      )}
    </Grid>
  );
};
